// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.row.react-bootstrap-table-pagination {
  margin-top: 20px;
  flex-wrap: nowrap;
}
@media (max-width: 991px) {
  .row.react-bootstrap-table-pagination {
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .row.react-bootstrap-table-pagination .col-md-6 {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .row.react-bootstrap-table-pagination .col-md-6 .react-bootstrap-table-page-btns-ul {
    float: none;
    margin-top: 1rem !important;
    margin-bottom: 0;
  }
}

.react-bootstrap-table {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
.react-bootstrap-table .table {
  margin-bottom: 0;
  table-layout: inherit;
}
.react-bootstrap-table .table thead {
  background-color: #dee2e6;
}
.react-bootstrap-table .table thead th {
  font-family: "proxima-nova", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 16px;
  vertical-align: top;
  font-weight: 600 !important;
  border-top: none !important;
  border-bottom: 1px solid #dee2e6 !important;
  text-align: center;
}
.react-bootstrap-table .table th,
.react-bootstrap-table .table td {
  width: auto;
  color: #1b2430;
  text-transform: capitalize;
  text-align: center;
}
.react-bootstrap-table .table th:first-child,
.react-bootstrap-table .table td:first-child {
  text-align: left;
}
.react-bootstrap-table .table td {
  font-family: "proxima-nova", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 14px;
  color: #6d6d6d;
  text-transform: capitalize;
}
.react-bootstrap-table .table .actions-buttons a,
.react-bootstrap-table .table .actions-buttons button {
  padding: 0.02rem !important;
  margin-right: 0.65rem;
  font-size: 14px;
}
.react-bootstrap-table .table .actions-buttons a :last-child,
.react-bootstrap-table .table .actions-buttons button :last-child {
  margin-right: 0;
}
.react-bootstrap-table .table .actions-buttons a i,
.react-bootstrap-table .table .actions-buttons button i {
  font-size: 12px;
}

.pagination .page-item .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.85rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #0000ff;
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 50%;
}
.pagination .page-item .page-link:hover {
  z-index: 2;
  color: #242424;
  text-decoration: none;
  background-color: #dee2e6;
  border: 1px solid #dee2e6;
}
.pagination .page-item.active .page-link {
  z-index: 1;
  color: #333333;
  background-color: #dee2e6;
  border: 1px solid #dee2e6 !important;
  border-radius: 50%;
}
.pagination .page-item:first-child .page-link, .pagination .page-item:last-child .page-link {
  margin-left: 2px;
  border: none;
}
.pagination .page-item:first-child .page-link:hover, .pagination .page-item:first-child .page-link:focus, .pagination .page-item:first-child .page-link.active, .pagination .page-item:last-child .page-link:hover, .pagination .page-item:last-child .page-link:focus, .pagination .page-item:last-child .page-link.active {
  background: transparent;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/student_module/components/data_tables/_datatable.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA9WA;EACE,gBAAA;EACA,iBAAA;AAiXF;AA/WE;EACE;IACE,kBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EAiXJ;EA9WE;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;EAgXJ;EA9WI;IACE,WAAA;IACA,2BAAA;IACA,gBAAA;EAgXN;AACF;;AA3WA;EACE,yBAAA;EACA,sBAAA;AA8WF;AA5WE;EACE,gBAAA;EACA,qBAAA;AA8WJ;AA5WI;EACE,yBAAA;AA8WN;AA5WM;EDXF,kDAJU;EAKV,0BAAA;EACA,2BAAA;EACA,iBCS8B;EAC1B,mBAAA;EACA,2BAAA;EACA,2BAAA;EACA,2CAAA;EACA,kBAAA;AAiXR;AA7WI;;EAEE,WAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;AA+WN;AA7WM;;EACE,gBAAA;AAgXR;AA5WI;EDjCA,kDAJU;EAKV,0BAAA;EACA,2BAAA;EACA,iBC+B4B;EAC1B,cAAA;EACA,0BAAA;AAiXN;AA9WI;;EAEE,2BAAA;EACA,qBAAA;EACA,eAAA;AAgXN;AA9WM;;EACE,eAAA;AAiXR;AA9WM;;EACE,eAAA;AAiXR;;AA1WE;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AA6WJ;AA3WI;EACE,UAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AA6WN;AAzWE;EACE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;AA2WJ;AAxWE;EAEE,gBAAA;EACA,YAAA;AAyWJ;AAvWI;EAGE,uBAAA;EACA,gBAAA;AAuWN","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import \"../../../config\";\n\n.row.react-bootstrap-table-pagination {\n  margin-top: 20px;\n  flex-wrap: nowrap;\n\n  @media (max-width: 991px) {\n    & {\n      text-align: center;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n\n    .col-md-6 {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .react-bootstrap-table-page-btns-ul {\n        float: none;\n        margin-top: 1rem !important;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.react-bootstrap-table {\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n\n  .table {\n    margin-bottom: 0;\n    table-layout: inherit;\n\n    thead {\n      background-color: #dee2e6;\n\n      th {\n        @include fonts(600, 14px, 16px);\n        vertical-align: top;\n        font-weight: 600 !important;\n        border-top: none !important;\n        border-bottom: 1px solid #dee2e6 !important;\n        text-align: center;\n      }\n    }\n\n    th,\n    td {\n      width: auto;\n      color: #1b2430;\n      text-transform: capitalize;\n      text-align: center;\n\n      &:first-child {\n        text-align: left;\n      }\n    }\n\n    td {\n      @include fonts(400, 14px, 14px);\n      color: #6d6d6d;\n      text-transform: capitalize;\n    }\n\n    .actions-buttons a,\n    .actions-buttons button {\n      padding: 0.02rem !important;\n      margin-right: 0.65rem;\n      font-size: 14px;\n\n      :last-child {\n        margin-right: 0;\n      }\n\n      i {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.pagination .page-item {\n  .page-link {\n    position: relative;\n    display: block;\n    padding: 0.5rem 0.85rem;\n    margin-left: -1px;\n    line-height: 1.25;\n    color: #0000ff;\n    background: transparent;\n    border: 1px solid #ffffff;\n    border-radius: 50%;\n\n    &:hover {\n      z-index: 2;\n      color: #242424;\n      text-decoration: none;\n      background-color: #dee2e6;\n      border: 1px solid #dee2e6;\n    }\n  }\n\n  &.active .page-link {\n    z-index: 1;\n    color: #333333;\n    background-color: #dee2e6;\n    border: 1px solid #dee2e6 !important;\n    border-radius: 50%;\n  }\n\n  &:first-child .page-link,\n  &:last-child .page-link {\n    margin-left: 2px;\n    border: none;\n\n    &:hover,\n    &:focus,\n    &.active {\n      background: transparent;\n      box-shadow: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
